const MODE = process.env.NEXT_PUBLIC_API_MOCKING;

/**
 * The hosted sales demo (demo.velys.jnj): a production build that deliberately
 * ships the mock graph. "demo" is a different value from local "enabled" on
 * purpose, so neither can be mistaken for the other, and next.config.ts refuses
 * it unless VELYS_BUILD_TARGET=demo is also set — two independent opt-ins, and
 * only the Dockerfile's demo target sets both. Still a compile-time literal, so
 * every non-demo build folds this to false exactly as before.
 */
export const DEMO_BUILD = MODE === "demo";

/**
 * The mock-mode kill switch. This is the ONLY place NEXT_PUBLIC_API_MOCKING is read.
 *
 * Deliberately `process.env` (build-time inlined) rather than next-runtime-env's
 * `env()`, which is what the rest of the app uses. That is a considered exception,
 * not an oversight:
 *
 * `.env.production.sample` bans NEXT_PUBLIC_* because inlining "defeats the
 * one-image-many-envs model". That rule is about per-environment *values* —
 * NEXT_PUBLIC_AUTHORITY, NEXT_PUBLIC_ASSETS_APPSYNC_URL, NEXT_PUBLIC_RUM_REGION —
 * where freezing a value into the bundle means a US image cannot serve EU. This
 * flag is not such a value: it is `false` in 100% of deployed images, in every
 * region, forever.
 *
 * And inlining is the entire point. Only a compile-time literal lets the bundler
 * prove the branch in AuthGateway dead and drop the whole src/mocks/** graph —
 * synthetic clinical fixtures, a WebSocket protocol emulator, and an auth provider
 * that hardcodes isAuthenticated:true — out of the shipped client bundle. A runtime
 * flag would necessarily ship all of it as a lazily-loadable chunk, reachable by
 * anyone who can set window.__ENV, and with productionBrowserSourceMaps:true the
 * readable source with it.
 *
 * This is layer 1 of four. See also: the PHASE_PRODUCTION_BUILD assertion in
 * next.config.ts (L2), the gitignored/dockerignored public/mockServiceWorker.js
 * (L3), and assertLocalOrigin() in ./guard.ts (L4).
 */
export const MOCKS_ENABLED =
  (MODE === "enabled" && process.env.NODE_ENV !== "production") || DEMO_BUILD;
